import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=623bf6f0&scoped=true&"
import script from "./FilterDropdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./FilterDropdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FilterDropdown.vue?vue&type=style&index=0&id=623bf6f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623bf6f0",
  null
  
)

export default component.exports